import { useSelector } from 'react-redux'
import { Box, Button, Grid, makeStyles, Tab } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import EmployeeType from 'src/components/ceo/EmployeeType'
import TopClaims from 'src/components/ceo/TopClaims'
import {
  CLIENT_TYPE,
  DASHBOARD_TABS,
  POLICY_TYPE,
  SXP_UPLOAD_POLICY_TYPE,
} from 'src/utils/constants/common'
import AllEndorsements from 'src/components/Individual/AllEndorsements'
import AllClaims from 'src/components/Individual/AllClaims'
import AllRenew from 'src/components/Individual/AllRenew'
import AllProducts from 'src/components/Individual/AllProducts'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {
  isCorporateAdmin,
  isCorporateCeo,
  isCorporateLeader,
  isCorporatePOC,
} from 'src/utils/commonMethods'
import UpcomingFeatures from 'src/components/common/UpcomingFeatures'
import PolicyDetails from 'src/components/Individual/PolicyDetails/PolicyDetails'
import ClaimAssureGuard from 'src/components/Individual/ClaimAssureGuard'
import InsuranceSpotlight from 'src/components/ceo/InsuranceSpotlight/InsuranceSpotlight'
import BuyInsurance from 'src/components/ceo/BuyInsurance'
import CdBalance from 'src/components/ceo/CDBalance/CdBalance'
import LinkedCompanies from 'src/components/common/LinkedCompanies'
import { GET_LINKED_COMPANIES } from 'src/services/corporateService'
import { useQuery } from '@apollo/client'

const CeoView = ({ clientId }) => {
  const classes = useStyles()
  const isCEO = true
  const [value, setValue] = useState(DASHBOARD_TABS?.COMPANY_POLICIES)
  const userInfo = useSelector((state) => state?.userInfo)
  const [dashboardTabList, setDashboardTabList] = useState([])
  const [isUploadPolicyOpen, setIsUploadPolicyOpen] = useState(false)
  const [childOptions, setChildOptions] = useState([])

  const userDashboardAccess = userInfo?.userInfo?.userData?.dashboardAccess

  const setTabs = () => {
    let dashboardTabs
    if (!isCorporatePOC(userInfo?.userInfo?.userData?.roles)) {
      dashboardTabs = [
        DASHBOARD_TABS?.BUYINSURANCE,
        DASHBOARD_TABS?.COMPANY_POLICIES,
        DASHBOARD_TABS?.MODIFICATIONS,
        DASHBOARD_TABS?.CLAIM_ASSUREGUARD,
        DASHBOARD_TABS?.INSURANCE_SPOTLIGHT,
      ]
      setDashboardTabList(dashboardTabs)
    } else {
      const userDetails = userInfo?.userInfo?.userData

      dashboardTabs = [DASHBOARD_TABS?.COMPANY_POLICIES]

      if (userDetails?.dashboardTabs?.buyPolicy) {
        dashboardTabs?.splice(0, 0, DASHBOARD_TABS?.BUYINSURANCE)
      }
      if (userDetails?.dashboardTabs?.endorsements) {
        dashboardTabs?.push(DASHBOARD_TABS?.MODIFICATIONS)
      }
      if (userDetails?.dashboardTabs?.claimAssureGuard) {
        dashboardTabs?.push(DASHBOARD_TABS?.CLAIM_ASSUREGUARD)
      }
      if (userDetails?.dashboardTabs?.insuranceSpotlight) {
        dashboardTabs?.push(DASHBOARD_TABS?.INSURANCE_SPOTLIGHT)
      }

      setDashboardTabList(dashboardTabs)
    }
  }

  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  const getMyPoliciesUrl = () => {
    if (
      isCorporateLeader(userInfo?.userInfo?.userData?.roles) ||
      isCorporateAdmin(userInfo?.userInfo?.userData?.roles)
    ) {
      return '/individual/dashboard/home'
    }
    return '/individual/dashboard'
  }

  const getTabName = (tabName) => {
    switch (tabName) {
      case DASHBOARD_TABS?.COMPANY_POLICIES:
        return <div className={classes.mainTab}>Insurance Policies</div>
      case DASHBOARD_TABS?.PRODUCTS:
        return <div>Products</div>
      case DASHBOARD_TABS?.RENEW:
        return <div>Renew</div>
      case DASHBOARD_TABS?.CLAIM:
        return <div>Claim</div>
      case DASHBOARD_TABS?.UPCOMING_FEATURES:
        return <div className={classes.mainTab}>Upcoming Features</div>
      case DASHBOARD_TABS?.MODIFICATIONS:
        return (
          <div className={classes.mainTab}>Policy Additions / Corrections</div>
        )
      case DASHBOARD_TABS?.CLAIM_ASSUREGUARD:
        return <div className={classes.mainTab}>Claim AssureGuard</div>
      case DASHBOARD_TABS?.INSURANCE_SPOTLIGHT:
        return <div className={classes.mainTab}>Insurance Spotlight</div>
      case DASHBOARD_TABS?.BUYINSURANCE:
        return <div className={classes.mainTab}>Buy Policies</div>
      default:
        return <div></div>
    }
  }

  const addPolicy = () => {
    setIsUploadPolicyOpen(true)
  }

  const closeUploadPolicyModal = () => {
    setIsUploadPolicyOpen(false)
  }

  const getTabComponents = (tabName) => {
    switch (tabName) {
      case DASHBOARD_TABS?.COMPANY_POLICIES:
        return (
          <>
            <PolicyDetails
              clientId={clientId}
              isCorporate={true}
              isCEO={isCEO}
              policyType={POLICY_TYPE?.COMPANY}
              clientType={CLIENT_TYPE?.CORPORATE}
              addPolicy={addPolicy}
              isUploadPolicyOpen={isUploadPolicyOpen}
              closeUploadPolicyModal={closeUploadPolicyModal}
            />
          </>
        )
      case DASHBOARD_TABS?.PRODUCTS:
        return (
          <>
            <AllProducts />
          </>
        )
      case DASHBOARD_TABS?.RENEW:
        return (
          <>
            <AllRenew />
          </>
        )
      case DASHBOARD_TABS?.CLAIM:
        return (
          <>
            <AllClaims />
          </>
        )
      case DASHBOARD_TABS?.UPCOMING_FEATURES:
        return (
          <>
            <UpcomingFeatures />
          </>
        )
      case DASHBOARD_TABS?.MODIFICATIONS:
        return (
          <>
            <AllEndorsements
              clientId={clientId}
              clientType={CLIENT_TYPE?.CORPORATE}
              policyType={SXP_UPLOAD_POLICY_TYPE?.CORPORATE}
            />
          </>
        )
      case DASHBOARD_TABS?.CLAIM_ASSUREGUARD:
        return (
          <>
            <ClaimAssureGuard
              clientId={clientId}
              emailId={userInfo?.userInfo?.userData?.emailId}
            />
          </>
        )
      case DASHBOARD_TABS?.INSURANCE_SPOTLIGHT:
        return (
          <>
            <InsuranceSpotlight />
          </>
        )
      case DASHBOARD_TABS?.BUYINSURANCE:
        return (
          <BuyInsurance
            clientId={clientId}
            emailId={userInfo?.userInfo?.userData?.emailId}
          />
        )
      default:
        return <></>
    }
  }

  const showMyPoliciesButton = () => {
    const roles = userInfo?.userInfo?.userData?.roles
    return isCorporateCeo(roles) || isCorporatePOC(roles)
  }

  const { data: linkedCompaniesData } = useQuery(GET_LINKED_COMPANIES(), {
    variables: { clientId: userInfo?.userInfo?.userData?.parentClientId },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const childCompaniesList =
    linkedCompaniesData?.getChildAndParentCompanyDetails
      ?.childCompanyDetailsList

  useEffect(() => {
    setChildOptions(childCompaniesList)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkedCompaniesData])

  useEffect(() => {
    setTabs()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const showStatsContainer = () => {
    return (
      !isCorporatePOC(userInfo?.userInfo?.userData?.roles) ||
      userDashboardAccess?.loggedInStats ||
      userDashboardAccess?.topClaims
    )
  }

  const showTopClaims = () => {
    return (
      !isCorporatePOC(userInfo?.userInfo?.userData?.roles) ||
      userDashboardAccess?.topClaims
    )
  }

  const showLoggedInStats = () => {
    return (
      !isCorporatePOC(userInfo?.userInfo?.userData?.roles) ||
      userDashboardAccess?.loggedInStats
    )
  }
  return (
    <>
      <div className={classes.mainGridContainer}>
        <Grid container alignItems='stretch' wrap='nowrap'>
          <Grid item className={classes.gridContainer}>
            <div className={classes.policyButtonsContainer}>
              {isCorporateLeader(userInfo?.userInfo?.userData?.roles) && (
                <Link
                  className={classes.linkStyles}
                  to={'/individual/dashboard/'}
                >
                  <Button
                    className={classes.buttonUploadPersonal}
                    // onClick={addPolicy}
                    margin={'0px'}
                  >
                    Leadership Dashboard
                  </Button>
                </Link>
              )}
              {showMyPoliciesButton() ? (
                <div className={classes.policyButtonContainer}>
                  <Link
                    className={classes.linkStyles}
                    to={{
                      pathname: getMyPoliciesUrl(),
                      state: { isCeoView: true },
                    }}
                  >
                    <Button className={classes.policyButton} margin={'0px'}>
                      My Policies
                    </Button>
                  </Link>
                </div>
              ) : null}

              {!isCorporateLeader(userInfo?.userInfo?.userData?.roles) && (
                <LinkedCompanies childOptions={childOptions} />
              )}
            </div>
            <Box className={classes.boxContainer}>
              <TabContext value={value}>
                <Box>
                  <TabList
                    id='tabList'
                    onChange={handleTabChange}
                    className={classes.tabListContainer}
                    variant='scrollable'
                  >
                    {dashboardTabList?.map((tabListItem) => (
                      <Tab
                        role={`${tabListItem}`}
                        key={`tab_${tabListItem}`}
                        label={getTabName(tabListItem)}
                        value={tabListItem}
                        wrapped
                        className={
                          value === tabListItem ? 'tab-selected' : 'tab'
                        }
                      />
                    ))}
                  </TabList>
                </Box>
                <>
                  {dashboardTabList?.map((tabListItem) => (
                    <TabPanel
                      key={`tabPanel_${tabListItem}`}
                      value={tabListItem}
                      className={'tab-panel'}
                    >
                      {getTabComponents(tabListItem)}
                    </TabPanel>
                  ))}
                </>
              </TabContext>
            </Box>
          </Grid>
          {showStatsContainer() ? (
            <Grid item className={classes.statsContainer}>
              <div>
                <CdBalance />
              </div>
              {showTopClaims() ? (
                <div className={classes.topClaimsContainer}>
                  <TopClaims />
                </div>
              ) : null}

              {showLoggedInStats() ? (
                <div className={classes.employeeTypeContainer}>
                  <EmployeeType
                    data-test='homeNewEmployeeType'
                    clientId={clientId}
                  />
                </div>
              ) : null}
            </Grid>
          ) : null}
        </Grid>
      </div>
    </>
  )
}

export default CeoView

const useStyles = makeStyles({
  mainGridContainer: {
    display: 'flex',
    width: '100%',
  },
  policyButtonContainer: {},
  gridContainer: {
    minWidth: '70%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: '30px 20px',
    gap: '10px',
    marginRight: 0,
  },
  tabListContainer: {
    '& .MuiTabs-flexContainer': {
      gap: '10px',
    },
  },
  linkStyles: {
    textDecoration: 'None',
    color: COLORS.MEDIUM_BLUE,
  },
  boxContainer: {
    borderBottom: '0.5px solid rgba(51, 51, 51, 0.3)',
    height: 'fit-content',
    // marginLeft: '10px',
  },
  root: {
    marginTop: '20px',
    marginLeft: '30px',
    // maxWidth: "69%",
  },
  buttonUploadPersonal: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.MEDIUM_LIGHTBLUE,
    color: COLORS.WHITE,
    height: '24px',
    // padding: '17px 15px !important',
    padding: '0px 10px',
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: COLORS.MEDIUM_LIGHTBLUE,
    },
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  loadingContainer: {
    margin: 'auto',
    position: 'absolute',
    left: '50%',
    top: '50%',
  },
  uploadPolicyImage: {
    width: '13px',
    paddingLeft: '5px',
  },
  statsContainer: {
    width: '30%',
    margin: '30px 20px',
  },
  employeeTypeContainer: {
    marginTop: '24px',
  },
  topClaimsContainer: {
    // marginTop: '-60px',
  },
  policyButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  policyButton: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.DARK_PINK,
    color: COLORS.WHITE,
    height: '24px',
    padding: '0px 10px',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: COLORS.DARK_PINK,
    },
  },
  mainTab: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '16.41px',
  },
})
